const integrationErrorResponseToIntegrationErrorObject = (response) => {
    return {
        lineNumber: response.line_number,
        externalOrderId: response.external_order_id,
        errorMessage: response.error_message
    };
};

export { integrationErrorResponseToIntegrationErrorObject };